// Values required by the API
export enum RECORDING_GROUP_STATUS {
    SUBMITTED = 'SUBMITTED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    SUPERSEDED = 'SUPERSEDED',
}

// Export a type for the form
export type RecordingGroupStatus = keyof typeof RECORDING_GROUP_STATUS
